import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';
import { Spinner } from '@heroui/react';
import { useAuth } from '@/contexts/AuthContext';

const CallbackPage: React.FC = () => {
  const navigate = useNavigate();
  const { isLoading: auth0Loading, isAuthenticated: auth0Authenticated, error: auth0Error } = useAuth0();
  const { isAuthenticated, isLoading: authLoading } = useAuth();
  useEffect(() => {
    if (!auth0Loading && !authLoading) {
      if (auth0Authenticated && isAuthenticated) {
        // Successfully authenticated, redirect to stored return path or home
        const returnPath = sessionStorage.getItem('returnPath') || '/';
        sessionStorage.removeItem('returnPath');
        navigate(returnPath);
      } else if (!auth0Authenticated && !auth0Error) {
        // Not authenticated, redirect to login
        navigate('/login');
      }
    }
  }, [auth0Loading, authLoading, auth0Authenticated, isAuthenticated, navigate, auth0Error]);

  if (auth0Error) {
    console.error('Auth0 error:', auth0Error);
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-900">
        <div className="text-center space-y-4">
          <p className="text-sm text-gray-600 dark:text-gray-400">Error: {auth0Error.message}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-900">
      <div className="text-center space-y-4">
        <Spinner size="lg" />
        <p className="text-sm text-gray-600 dark:text-gray-400">Completing sign in...</p>
      </div>
    </div>
  );
};

export default CallbackPage;
